import { cn } from "@newxsystems/shared";
import { AbyssCardLink } from "../AbyssCardLink/AbyssCardLink";
import { AbyssMedia } from "../AbyssMedia/AbyssMedia";
import { AbyssRichText } from "../AbyssRichText/AbyssRichText";
import type { IImageContentGridBottomProps } from "./ImageContentGridBottom.props";

const columns = {
  1: "lg:grid-cols-1",
  2: "lg:grid-cols-2",
  3: "lg:grid-cols-3",
  4: "lg:grid-cols-4",
} as const;

export const ImageContentGridBottom = ({
  columnCount,
  imageAspectRatio,
  items,
}: IImageContentGridBottomProps) => (
  <div
    className={cn(
      "grid grid-cols-1 border-l border-t border-iron sm:grid-cols-2",
      columns[columnCount || 3],
    )}
  >
    {items.map((item, index) => (
      <AbyssCardLink
        className={cn(
          "flex flex-col border-b border-r border-t-0 border-iron bg-obsidian/25",
          item.cardLink &&
            "before:pointer-events-none before:absolute before:-left-px before:inset-y-0 before:z-10 before:w-px before:bg-primary before:opacity-0 before:transition-opacity before:duration-200 before:content-[''] hover:before:opacity-100",
        )}
        key={index}
        link={item.cardLink}
      >
        <div className="flex-1 p-7 md:p-9">
          <h3 className="abyss-type-subhead font-abyss-display font-medium transition-colors group-hover:text-primary">
            {item.heading}
          </h3>
          {item.description ? (
            <AbyssRichText
              className="mt-4 text-base text-fog md:text-lg"
              content={item.description}
            />
          ) : null}
        </div>
        <AbyssMedia
          aspectRatio={imageAspectRatio || "16:9"}
          className="ring-1 ring-inset ring-frost/10"
          media={item.image.image}
          sizes="(min-width: 1024px) 33vw, (min-width: 640px) 50vw, 100vw"
        />
      </AbyssCardLink>
    ))}
  </div>
);

ImageContentGridBottom.displayName = "Content::ImageContentGridBottom";
